import React from 'react';
import { motion } from 'framer-motion';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
  highlight?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  centered = true,
  highlight,
}) => {
  const formattedTitle = highlight
    ? title.replace(highlight, `<span class="text-accent">${highlight}</span>`)
    : title;

  return (
    <div className={`mb-10 ${centered ? 'text-center' : ''}`}>
      <motion.h2
        className="text-2xl md:text-3xl font-bold font-display mb-4"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        dangerouslySetInnerHTML={{ __html: formattedTitle }}
      />
      {subtitle && (
        <motion.p
          className="text-gray-600 max-w-2xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
};

export default SectionHeader;